import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 33\" id=\"icon-star\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m10.313 19.92-1.461 8.955 7.648-4.228 7.648 4.228-1.46-8.955 6.187-6.341-8.55-1.307L16.5 4.125l-3.824 8.147-8.551 1.307 6.188 6.341Z\" fill=\"#111921\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol